export const INSURED_PERSONS_FIELD_NAME = 'insuredPersons';
export const NEW_PREMIUM_FIELD_NAME = 'newPremium';
export const PAYMENT_METHOD_FIELD_NAME = 'paymentMethod';
export const INSPECTION_FIELD_NAME = 'inspection';
export const NEW_PREMIUM_STEP_NAME = 'new-premium';
export const INFO_STEP_NAME = 'confirmation-needed';
export const DOCUMENTS_STATEMENTS_NAME = 'statementsForDocuments';
